import * as React from 'react'

import { CartButton } from '@grandvisionhq/carts-v2'
import { MenuItemType } from '@grandvisionhq/layout'
import { CmsLayoutSettings, withCmsLayout } from '@grandvisionhq/next'

export const settings: CmsLayoutSettings = {
  renderCartButton: (item: MenuItemType): JSX.Element => {
    const props = {
      key: item.label,
      label: item.label,
      href: item.link?.href,
      className: 'header-menu__icon',
    }
    return <CartButton {...props} />
  },
}

export default withCmsLayout(settings)
